import { render } from "./TrialOverview.vue?vue&type=template&id=c04944ac&scoped=true"
import script from "./TrialOverview.vue?vue&type=script&lang=js"
export * from "./TrialOverview.vue?vue&type=script&lang=js"

import "./TrialOverview.vue?vue&type=style&index=0&id=c04944ac&scoped=true&lang=css"
import "./TrialOverview.vue?vue&type=style&index=1&id=c04944ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c04944ac"]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Ripple from 'quasar/src/directives/Ripple.js';
import TouchHold from 'quasar/src/directives/TouchHold.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QSkeleton,QBtn,QTooltip,QTable,QTr,QTh,QBadge,QPopupEdit,QInput,QTd,QIcon,QMenu,QSeparator,QList,QItem,QItemSection,QSpinner});qInstall(script, 'directives', {ClosePopup,Ripple,TouchHold});
